const tokens = {
  bnb: {
    symbol: 'BNB',
    projectLink: 'https://www.binance.com/',
  },
  plan: {
    symbol: 'PLAN',
    address: {
      56: '0xdd8E8B0D2E695d19e907EAA8C129Aa785c57562c',
      97: '0xa35062141Fa33BCA92Ce69FeD37D0E8908868AAe',
    },
    decimals: 18,
    projectLink: 'http://www.orbitswap.finance/',
  },
  wbnb: {
    symbol: 'BNB',
    address: {
      56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      97: '',
    },
    decimals: 18,
    projectLink: 'https://binance.com',
  },
  ankr: {
    symbol: 'ANKR',
    address: {
      56: '0xf307910A4c7bbc79691fD374889b36d8531B08e3',
      97: '',
    },
    decimals: 18,
    projectLink: 'https://ankr.com',
  }
}

export default tokens
